export const ROUTER_PATH = 'engagement/churn';

export const nightingaleChurnDefaultSelector = [
  {
    "name_cn": "区服",
    "name_en": "Zone",
    "key": "zone",
    "visible": 0,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "区域",
    "name_en": "Region",
    "key": "region",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "渠道",
    "name_en": "Channel",
    "key": "channel",
    "visible": 0,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "平台",
    "name_en": "Platform",
    "key": "system",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "语言",
    "name_en": "Language",
    "key": "lang",
    "visible": 0,
    "default": ["255"]
  },
  {
    "name_cn": "流失等级",
    "name_en": "Churn Level",
    "key": "churn_level",
    "visible": 1,
    "default": ["255"]
  },
];
